<div class="notice-modal-root" *transloco="let t">
  <app-header>
    <div class="header">
      <div class="title">
        {{title}}
      </div>
      <button id="close-filter-date-icon" (click)="onCloseClick()" mat-icon-button class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </app-header>
  <div class="body" [innerHTML]="body">
  </div>
  <div class="footer">
    <div class="buttons">
      <button mat-stroked-button class="close-button" (click)="onCloseClick()">{{t('close')}}</button>
      <button mat-flat-button class="dynamic-button" *ngIf="button" (click)="redirect(button.href)">{{button.title}}</button>
    </div>
  </div>
</div>
